import { useId } from 'react';

export const JiraBoxIcon = ({
  width,
  height,
  className,
}: {
  width?: number;
  height?: number;
  className?: string;
}) => {
  const maskId = useId();

  return (
    <svg
      width={width ?? '20'}
      height={height ?? '20'}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Jira Icon"
      className={className}
    >
      <title>Jira</title>
      <path
        d="M2 6C2 3.79086 3.79086 2 6 2H14C16.2091 2 18 3.79086 18 6V14C18 16.2091 16.2091 18 14 18H6C3.79086 18 2 16.2091 2 14V6Z"
        fill="#1868DB"
      />
      <mask
        id={maskId}
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="5"
        width="11"
        height="11"
      >
        <path d="M14.8108 5.46338H4.74609V15.6061H14.8108V5.46338Z" fill="white" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M7.98274 12.3491H7.08121C5.72151 12.3491 4.74609 11.5163 4.74609 10.2968H9.59371C9.84494 10.2968 10.0075 10.4752 10.0075 10.7281V15.6061C8.79561 15.6061 7.98274 14.6245 7.98274 13.2563V12.3491ZM10.377 9.92501H9.47548C8.11578 9.92501 7.14034 9.10705 7.14034 7.88755H11.9879C12.2392 7.88755 12.4165 8.05111 12.4165 8.30395V13.182C11.2046 13.182 10.377 12.2004 10.377 10.8322V9.92501ZM12.786 7.51575H11.8845C10.5248 7.51575 9.54934 6.68291 9.54934 5.46338H14.397C14.6482 5.46338 14.8108 5.64185 14.8108 5.87981V10.7578C13.5989 10.7578 12.786 9.77628 12.786 8.40805V7.51575Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
